export default "__VITE_PUBLIC_ASSET__7308164a__"